import type { PnidGraph } from './graphIndex'
import type { GraphNode } from './graphTypes'

export type CanvasPoint = { denormalized_x: number; denormalized_y: number }

export type CanvasGeometry =
  | { type: 'polygon'; points: CanvasPoint[] }
  | { type: 'polyline'; points: CanvasPoint[] }

export type PageCanvasBounds = {
  denormalized_x: number
  denormalized_y: number
  denormalized_width: number
  denormalized_height: number
}

export type PageCanvas = {
  pageNumber: number
  graph: PnidGraph
  bounds: PageCanvasBounds
}

export type PageGraphSource = Pick<PageCanvas, 'pageNumber' | 'graph'>
export const EMPTY_PAGE_GRAPH_SOURCES: PageGraphSource[] = []

export type NodeOverlay = {
  overlayId: string
  pageId: string
  node: GraphNode
  geometry: CanvasGeometry
}

export type TooltipRow = { label: string; value: string }
export type NodeTooltip = {
  title: string
  subtitle?: string
  rows: TooltipRow[]
}
